import { render, staticRenderFns } from "./familyForm.vue?vue&type=template&id=46566766&scoped=true"
import script from "./familyForm.vue?vue&type=script&lang=js"
export * from "./familyForm.vue?vue&type=script&lang=js"
import style0 from "./familyForm.vue?vue&type=style&index=0&id=46566766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46566766",
  null
  
)

export default component.exports